export default "__VITE_ASSET__Cy3dzmtA__"